export enum GemShape {
  Oval = 'Oval',
  Round = 'Round',
  Emerald = 'Emerald',
  Pear = 'Pear',
  Octagonal = 'Octagonal',
  Square = 'Square',
  Marquise = 'Marquise',
  Heart = 'Heart',
  Triangular = 'Triangular',
  Radiant = 'Radiant',
  Kite = 'Kite',
  Cushion = 'Cushion',
  Trilliant = 'Trilliant',
  Hexagonal = 'Hexagonal',
  Other = 'Other',
}
